import { PayableChargeReducerDispatch, PayableChargeReduxState, PayableChargeReduxTypes, CreatePayableChargeReduxState } from "./types";

const PAYABLE_CHARGE_LIST_INIT_STATE = {
  data: {
    metadata: {
      totalCount: 0,
      currentPageRecords: 0,
      totalPages: 0,
      links: {
        self: null,
        first: null,
        previous: null,
        next: null,
        last: null
      }
    },
    records: []
  },
  loading: false,
  error: null
};

const PayableChargeListReducer = (state: PayableChargeReduxState = PAYABLE_CHARGE_LIST_INIT_STATE, action: PayableChargeReducerDispatch) => {
  switch (action.type) {
    case PayableChargeReduxTypes.FETCH_PAYABLE_CHARGES: {
      return {
        ...state,
        data: action.payload.data,
        loading: true
      };
    }
    case PayableChargeReduxTypes.FETCH_PAYABLE_CHARGES_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case PayableChargeReduxTypes.FETCH_PAYABLE_CHARGES_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }

    case PayableChargeReduxTypes.RESET:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const CREATE_CITY_INIT_STATE = {
  data: {},
  loading: false,
  error: null
};

const CreatePayableChargeReducer = (state: CreatePayableChargeReduxState = CREATE_CITY_INIT_STATE, action: PayableChargeReducerDispatch) => {
  switch (action.type) {
    case PayableChargeReduxTypes.CREATE_PAYABLE_CHARGE_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case PayableChargeReduxTypes.CREATE_PAYABLE_CHARGE_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case PayableChargeReduxTypes.RESET:
      return {
        ...state,
        data: {},
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const UpdatePayableChargeReducer = (state: CreatePayableChargeReduxState = CREATE_CITY_INIT_STATE, action: PayableChargeReducerDispatch) => {
  switch (action.type) {
    case PayableChargeReduxTypes.UPDATE_PAYABLE_CHARGE_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case PayableChargeReduxTypes.UPDATE_PAYABLE_CHARGE_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case PayableChargeReduxTypes.RESET:
      return {
        ...state,
        data: {},
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const PayableChargeReducer = (state: CreatePayableChargeReduxState = CREATE_CITY_INIT_STATE, action: PayableChargeReducerDispatch) => {
  switch (action.type) {
    case PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case PayableChargeReduxTypes.RESET:
      return {
        ...state,
        data: {},
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const PayableChargeVersionDetailsReducer = (state: CreatePayableChargeReduxState = CREATE_CITY_INIT_STATE, action: PayableChargeReducerDispatch) => {
  switch (action.type) {
    case PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_DETAILS: {
      return {
        loading: true
      };
    }
    case PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_DETAILS_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_DETAILS_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case PayableChargeReduxTypes.RESET:
      return {
        ...state,
        data: {},
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const PayableChargeLatestVersionReducer = (state: CreatePayableChargeReduxState = CREATE_CITY_INIT_STATE, action: PayableChargeReducerDispatch) => {
  switch (action.type) {
    case PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_LATEST_VERSION: {
      return {
        loading: true
      };
    }
    case PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_LATEST_VERSION_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_LATEST_VERSION_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case PayableChargeReduxTypes.RESET:
      return {
        ...state,
        data: {},
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const DeletePayableChargeReducer = (state: CreatePayableChargeReduxState = CREATE_CITY_INIT_STATE, action: PayableChargeReducerDispatch) => {
  switch (action.type) {
    case PayableChargeReduxTypes.DELETE_PAYABLE_CHARGE: {
      return {
        loading: true
      };
    }
    case PayableChargeReduxTypes.DELETE_PAYABLE_CHARGE_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case PayableChargeReduxTypes.DELETE_PAYABLE_CHARGE_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case PayableChargeReduxTypes.RESET:
      return {
        ...state,
        data: {},
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const PayableChargeListVersionReducer = (state: PayableChargeReduxState = PAYABLE_CHARGE_LIST_INIT_STATE, action: PayableChargeReducerDispatch) => {
  switch (action.type) {
    case PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case PayableChargeReduxTypes.FETCH_PAYABLE_CHARGE_VERSION_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }

    case PayableChargeReduxTypes.RESET:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const ApprovePayableChargeReducer = (state: CreatePayableChargeReduxState = CREATE_CITY_INIT_STATE, action: PayableChargeReducerDispatch) => {
  switch (action.type) {
    case PayableChargeReduxTypes.APPROVE_PAYABLE_CHARGE: {
      return {
        ...state,
        data: action.payload.data,
        loading: true
      };
    }
    case PayableChargeReduxTypes.APPROVE_PAYABLE_CHARGE_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case PayableChargeReduxTypes.APPROVE_PAYABLE_CHARGE_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }

    case PayableChargeReduxTypes.RESET:
      return {
        ...state,
        data: {},
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const RejectPayableChargeReducer = (state: CreatePayableChargeReduxState = CREATE_CITY_INIT_STATE, action: PayableChargeReducerDispatch) => {
  switch (action.type) {
    case PayableChargeReduxTypes.REJECT_PAYABLE_CHARGE: {
      return {
        ...state,
        data: action.payload.data,
        loading: true
      };
    }
    case PayableChargeReduxTypes.REJECT_PAYABLE_CHARGE_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case PayableChargeReduxTypes.REJECT_PAYABLE_CHARGE_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }

    case PayableChargeReduxTypes.RESET:
      return {
        ...state,
        data: {},
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const BlockPayableChargeReducer = (state: CreatePayableChargeReduxState = CREATE_CITY_INIT_STATE, action: PayableChargeReducerDispatch) => {
  switch (action.type) {
    case PayableChargeReduxTypes.BLOCK_PAYABLE_CHARGE_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case PayableChargeReduxTypes.BLOCK_PAYABLE_CHARGE_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }

    case PayableChargeReduxTypes.RESET:
      return {
        ...state,
        data: {},
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const FreezePayableChargeReducer = (state: CreatePayableChargeReduxState = CREATE_CITY_INIT_STATE, action: PayableChargeReducerDispatch) => {
  switch (action.type) {
    case PayableChargeReduxTypes.FREEZE_PAYABLE_CHARGE_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case PayableChargeReduxTypes.FREEZE_PAYABLE_CHARGE_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }

    case PayableChargeReduxTypes.RESET:
      return {
        ...state,
        data: {},
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const UnFreezePayableChargeReducer = (state: CreatePayableChargeReduxState = CREATE_CITY_INIT_STATE, action: PayableChargeReducerDispatch) => {
  switch (action.type) {
    case PayableChargeReduxTypes.UNFREEZE_PAYABLE_CHARGE_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case PayableChargeReduxTypes.UNFREEZE_PAYABLE_CHARGE_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }

    case PayableChargeReduxTypes.RESET:
      return {
        ...state,
        data: {},
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

export {
  PayableChargeListReducer,
  PayableChargeReducer,
  CreatePayableChargeReducer,
  UpdatePayableChargeReducer,
  PayableChargeListVersionReducer,
  ApprovePayableChargeReducer,
  RejectPayableChargeReducer,
  BlockPayableChargeReducer,
  FreezePayableChargeReducer,
  UnFreezePayableChargeReducer,
  PayableChargeVersionDetailsReducer,
  PayableChargeLatestVersionReducer,
  DeletePayableChargeReducer
};
